var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBullIconHalf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 122.88 104.57",
    viewBox: "0 0 61.432 104.55",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m43.701 0c3.8 14.8 5.5497 34.319-17.57 33.619-0.57-2.17-1.7197-3.5988-3.6797-3.9688-8.73-0.34-15.491-2.5501-21.221-2.5801-0.41129-0.0019-0.82047 0.02864-1.2305 0.04297v76.748c5.1033 0.83871 10.145 1.5945 12.252-2.0508 4.67 0.23 8.2195-1.49 10.02-6.25 1.39-2.78 1.3188-5.8712-0.28125-9.2812 0.14-2.48 0.07063-5.0088 0.14062-7.4688 0.09-3.08 0.05031-3.7704 1.8203-6.1504 4.15-5.59 8.8096-10.64 9.3496-13.49 0.78-0.57 1.6702-0.82023 2.6602-0.74023 0.33 0.03 0.66953 0.08945 1.0195 0.18945 16.76 7.4 19.911-5.2798 24.451-5.8398-5.52-1.22-10.16-5.6096-18.41-5.8496 20.58-11.23 16.89-33.85 0.67969-46.93z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullIconHalf);
export default __webpack_public_path__ + "static/media/BullIconHalf.7f58cd4472774b5cd647e1b1d5516d56.svg";
export { ForwardRef as ReactComponent };